import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    datetime: String,
    format: { type: String, default: "medium" },
  }

  connect() {
    this.render()
  }

  render() {
    if (!this.datetimeValue) return

    const date = new Date(this.datetimeValue)
    if (Number.isNaN(date.getTime())) return

    const formatter = new Intl.DateTimeFormat(undefined, this.formatOptions())
    this.element.textContent = formatter.format(date)
    this.element.dateTime = date.toISOString()
  }

  formatOptions() {
    switch (this.formatValue) {
      case "short":
        return { dateStyle: "short", timeStyle: "short" }
      case "long":
        return { dateStyle: "medium", timeStyle: "medium" }
      default:
        return {
          month: "short",
          day: "numeric",
          hour: "numeric",
          minute: "2-digit",
        }
    }
  }
}
